import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '@src/redux/store.ts'

/** 사운드 상태 초기값 설정 */
const initialState: any = {
  playingSounds: {}, // 현재 재생 중인 사운드 ID 목록
  pausedSounds: {}, // 일시 정지된 사운드 ID 목록
  isAllSoundsPaused: false, // 모든 사운드가 일시 정지되었는지 여부
  isAllSoundsMuted: false, // 모든 사운드가 음소거되었는지 여부
}

/** 사운드 관리를 위한 슬라이스 정의 */
const howlerSlice = createSlice({
  name: 'howler',
  initialState,
  reducers: {
    /** 초기 사운드 상태 설정 */
    setInitialSounds: (state, { payload }) => {
      Object.assign(state, initialState)
      state.playingSounds = payload
      state.pausedSounds = payload
    },
    /** 재생 중인 사운드 ID 추가 */
    addPlayingSoundId: (state, { payload }) => {
      const { name, id } = payload
      state.playingSounds[name].push(id)
    },
    /** 재생 중인 사운드 제거 */
    removePlayingSound: (state, { payload }) => {
      const { name } = payload
      state.playingSounds[name] = []
    },
    /** 특정 재생 중인 사운드 ID 제거 */
    removePlayingSoundId: (state, { payload }) => {
      const { name, id } = payload
      const index = state.playingSounds[name]?.indexOf(id)
      index !== -1 && state.playingSounds[name]?.splice(index, 1)
    },
    /** 모든 사운드 일시 정지 */
    addPauseAllSounds: (state) => {
      const pausedSounds = Object.assign({}, state.pausedSounds)
      state.pausedSounds = Object.assign({}, state.playingSounds)
      state.playingSounds = pausedSounds
      state.isAllSoundsPaused = true
    },
    /** 모든 사운드 재생 재개 */
    addResumeAllSounds: (state) => {
      const playingSounds = Object.assign({}, state.playingSounds)
      state.playingSounds = Object.assign({}, state.pausedSounds)
      state.pausedSounds = playingSounds
      state.isAllSoundsPaused = false
    },
    /** 모든 사운드 음소거 설정 */
    setIsAllSoundsMuted: (state, { payload }) => {
      state.isAllSoundsMuted = payload
    },
  },
})

export const {
  setInitialSounds,
  addPlayingSoundId,
  removePlayingSound,
  removePlayingSoundId,
  addPauseAllSounds,
  addResumeAllSounds,
  setIsAllSoundsMuted,
} = howlerSlice.actions

export const howlerSelector = (state: RootState) => state.howler

export default howlerSlice.reducer
